<div class="control-buttons">
	<button class="control-button" mat-flat-button (click)="formatJson()">Format JSON</button>
	<button class="control-button" mat-flat-button (click)="saveAnswers()">Save</button>
	<button class="control-button" mat-flat-button (click)="completeSurvey()">Complete</button>
</div>

<textarea #answerJson rows="50"
          (keyup)="checkKey($event)"
          (click)="setPosition()"
          (input)="setPosition()"></textarea>

<div>{{ position }}</div>
